<div class="modal-container">
  <div class="data-container">
    <div class="title-wrapper">
      <button
        type="button"
        class="header-icon-btn"
        (click)="closeDrawer()"
        data-dismiss="modal">
        <ng-icon name="lucideChevronsRight" size="1.25rem"></ng-icon>
      </button>
      <p>Error Details</p>
    </div>

    <div class="json-container">
      <pre>{{ errorJson }}</pre>
    </div>
  </div>
</div>
